export default __webpack_public_path__ + "static/mint-button-2e45a167f82fb3dc6db922850623872d.png";